import React, { useState, useRef } from "react";

import isUrl from "is-url";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useEditor } from "slate-react";

import { logout } from "../../../actions/baseActions";
import URL$1 from "../../../config/api";
import axios from "../../../config/axios";

import "./styles.css";

const TextEditorInsertingModal = props => {
  const editor = useEditor();
  const inputRef = useRef();
  const [imageSrc, setImageSrc] = useState(undefined);
  const [imageUrlChecker, setImageUrlChecker] = useState("null");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageName, setImageName] = useState(undefined);

  const saveImageUrl = async url => {
    try {
      const file = await createFileFromUrl(url);
      if (file) {
        await saveImage(file);
      }
    } catch (error) {
      return null;
    }
  };

  const createFileFromUrl = async url => {
    try {
      // Substitui a URL externa pela rota do backend proxy
      const proxyUrl = `${
        URL$1.api
      }content/los/proxyImage?url=${encodeURIComponent(url)}`;
      const response = await fetch(proxyUrl, {
        method: "GET",
        headers: {}
      });

      if (!response.ok) {
        throw new Error(`Erro ao buscar imagem: ${response.statusText}`);
      }

      const blob = "bloc";

      if (blob.size === 0) {
        throw new Error("O blob retornado está vazio. Verifique o backend.");
      }

      // Crie uma URL para o blob e exiba no body do HTML
      const imageURL = URL.createObjectURL(blob);

      // Adicione dinamicamente um elemento de imagem ao body
      const imgElement = document.createElement("img");
      imgElement.src = imageURL;
      imgElement.alt = "Imagem retornada do proxy";
      imgElement.style.maxWidth = "100%";
      imgElement.style.border = "2px solid #000";
      document.body.appendChild(imgElement);

      const fileName = `1`;
      const file = new File([blob], fileName, { type: blob.type });

      return file;
    } catch (error) {
      return null;
    }
  };

  const saveImage = async selectedImageFile => {
    try {
      const file = new FormData();
      file.append("filepond", selectedImageFile);

      const resp = await axios.post(
        `${URL$1.api}file/question_images/${props.userId}`,
        file,
        {
          headers: {
            authorization: `Bearer ${props.user.token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      if (resp.data.success) {
        setImageSrc(URL$1.img + resp.data.url); // Atualiza o estado com a URL da imagem
        setSelectedImage(selectedImageFile); // Define a imagem selecionada
        setImageName(resp.data.name); // Armazena o nome da imagem
      }
    } catch (error) {
      return null;
    }
  };

  const checkUrl = url => {
    isUrl(url) ? setImageUrlChecker(true) : setImageUrlChecker(false);
  };

  const deleteImage = () => {
    const imageToDelete = {
      name: imageName
    };

    axios
      .post(
        `${URL$1.api}removeFile/question_images/${props.userId}`,
        imageToDelete,
        { headers: { authorization: `Bearer ${props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          setImageName(undefined);
        }
      });
  };

  const cancelImageImporterModal = () => {
    if (!imageSrc && !selectedImage) return props.hideImageImporter();
    if (
      window.confirm(
        "Se você sair agora não enviará sua imagem. Deseja cancelar mesmo assim?"
      )
    ) {
      setImageSrc(undefined);
      setSelectedImage(null);
      setImageUrlChecker("null");
      props.hideImageImporter();
      deleteImage();
    }
  };

  const handleConfirm = async () => {
    if (!imageSrc) return;
    if (isUrl(imageSrc)) {
      await saveImageUrl(imageSrc); // Salva a URL da imagem
    }
    props.insertImage(editor, imageSrc); // Insere a imagem no editor
    resetImages();
  };

  const resetImages = () => {
    setImageSrc(undefined);
    setSelectedImage(null);
    setImageUrlChecker("null");
    props.hideImageImporter();
  };

  return (
    <div
      className={
        props.show
          ? "image-importer-modal image-importer-display-block"
          : "image-importer-modal image-importer-display-none"
      }
    >
      <section className="image-importer-modal-main">
        <h5 className="mb-3">Selecione uma URL:</h5>
        <section className="url-image-importer">
          <input
            type="url"
            onKeyUp={e => {
              setImageSrc(e.target.value);
              checkUrl(e.target.value);
            }}
            className={
              imageUrlChecker
                ? "url-image-importer-true"
                : "url-image-importer-false"
            }
            placeholder="URL da imagem"
            readOnly={selectedImage !== null}
          />
          {!imageUrlChecker && selectedImage === null && (
            <p>Insira uma URL válida</p>
          )}
        </section>
        <h5 className="mb-3">Ou importe uma imagem:</h5>
        <section className="local-image-importer">
          <input
            type="file"
            accept="image/jpg, image/png"
            hidden
            ref={inputRef}
            onChange={e => saveImage(e.target.files[0])}
          />
          {selectedImage === null ? (
            <button
              onClick={() => {
                inputRef.current.click();
              }}
              className="local-image-importer-button"
            >
              Importar Imagem
            </button>
          ) : (
            <img src={imageSrc} alt="" className="locally-imported-image" />
          )}
        </section>
        <div className="image-importer-submit-menu">
          <button
            onClick={() => cancelImageImporterModal()}
            className="cancel-image-importer-button"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="btn submit-image-importer-button"
            disabled={!imageSrc}
            onMouseDown={e => {
              e.preventDefault();
              handleConfirm(); // Chama a função para confirmar
            }}
          >
            Confirmar
          </button>
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TextEditorInsertingModal);
